<template>
  <div class="report">
    <!--<div v-for="(items,index) in list">-->
      <div class="title">{{name}}</div>
      <div class="head">统计日期: {{start}} 至 {{end}}</div>
      <table>
        <tr>
          <th >转运司机</th>
          <th >车牌号</th>
          <th >周转箱</th>
          <th >塑料袋</th>
          <th >月底车上剩余塑料袋</th>
          <th >门卫发放周转箱</th>
          <th >门卫发放塑料袋</th>
          <th >驾驶员发放减⻔卫发放塑料袋</th>
        </tr>
        <!--<tr>-->
          <!--<th>利器盒</th>-->
          <!--<th>塑料袋</th>-->
          <!--<th>周转箱</th>-->
          <!--<th>利器盒</th>-->
          <!--<th>塑料袋</th>-->
          <!--<th>利器盒</th>-->
          <!--<th>塑料袋</th>-->
        <!--</tr>-->
        <tr v-for="item in list">
          <td>{{item[0]}}</td>
          <td>{{item[1]}}</td>
          <td>{{item[2]}}</td>
          <td>{{item[3]}}</td>
          <td>{{item[4]}}</td>
          <td>{{item[5]}}</td>
          <td>{{item[6]}}</td>
          <td>{{item[7]}}</td>
        </tr>
      </table>
    </div>
  <!--</div>-->
</template>
<script>
  import Config from "../config.js"
  export default {
    name: "Grant1",
    data(){
      return {
        name:"领⽤物品发放表",
        list:[],
        start:"ss",
        end:"ss"
      }
    },
    methods:{
      init(){
        this.request(Config.HTTP+"upload?key="+this.$route.query.key,(res)=>{
          console.log(res.start,res.end,res.list)
          this.list=res.list;
          //this.name=res.name;
          this.start=res.start;
          this.end=res.end;
        } )
      },

    },
    created(){this.init()}
  }

</script>
<style scoped>
  .report{width: 100%;color: #000;}
  .report .title{height:60px;line-height: 60px;font-weight: bold;font-size: 16px;}
  table{border-collapse: collapse;width: 100%;}
  table td{border: 1px solid #000;font-size: 12px;height: 30px;}
  table th{border: 1px solid #000;font-size: 12px;height:30px;}
  .head{text-align: left;}
</style>






// WEBPACK FOOTER //
// src/view/report/grantSum.vue